import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import React, { Fragment, useEffect, useState } from "react";

import Notification from "pages/_components/Notification";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { connect } from "react-redux";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";

import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";

import MainContainer from "pages/_components/MainContainer";
import gaEventTracker, { events } from "util/gaEventTracker";
import MovementDetailList from "./MovementDetailList";
import { customMovementDetailPropType, defaultCustomMovementDetailPropType } from "./customMovementDetailPropType";

const CustomMovementDetail = (props) => {
    const { fetching, movement, dispatch, account, isDesktop } = props;

    const [fetchingState, setFetchingState] = useState(fetching);

    useEffect(() => {
        setFetchingState(false);
    }, [dispatch]);

    const handleDownloadClick = () => {
        gaEventTracker.triggerEvent(events.cuentas_detalle_movimientos_descargar());
        dispatch(accountsActions.downloadMovement(movement, "pdf"));
    };

    // const handleClick = () => {
    //     dispatch(accountsActions.toggleOptions());
    // };

    // const renderMenuOption = () => {
    //     const { isMobile, dispatch } = this.props;

    //     const handleClick = () => {
    //         dispatch(accountsActions.toggleOptions());
    //     };
    //     return (
    //         <>
    //             {isMobile && (
    //                 <div className="toolbar-item commands-mobile">
    //                     <Button
    //                         className="toolbar-btn view-options"
    //                         onClick={handleClick}
    //                         image="images/figma/icon/menu-mobile.svg"
    //                         label="view more options"
    //                         block={false}
    //                         bsStyle="link"
    //                     />
    //                 </div>
    //             )}
    //         </>
    //     );
    // };

    const renderMenuOption = () => (
        <>
            {isDesktop ? (
                <div className="toolbar-item  add-button" key="addMoreButtonsRight">
                    <Button
                        className="btn-outline"
                        onClick={handleDownloadClick}
                        image="images/figma/icon/download.svg"
                        label="global.download"
                    />
                </div>
            ) : (
                null
            )}
        </>
    );
    // const moreButtonsRight = () => (
    //     <div className="toolbar-item  add-button" key="addMoreButtonsRight">
    //         <Button className="btn-outline" onClick={handleDownloadClick}>
    //             <Image src="images/figma/icon/download.svg" />
    //             <I18n id="accounts.movement.detail.title" />
    //         </Button>
    //     </div>
    // );

    return (
        !fetchingState &&
        movement && (
            <Fragment>
                <Notification scopeToShow="movementDetail" />
                <CustomProductHead
                    titleId="accounts.movement.detail.title"
                    className="movement-details"
                    titleText={movement.title ? movement.title : movement.idProduct}
                    backLinkTo={`/accounts/${account.idProduct}`}
                    // addLinkToLabel="accounts.movement.detail.title"
                    // addLinkTo="/accounts/requestForm"
                    // exportList="accounts.accountBanner.balances"
                    renderMenuOption={renderMenuOption}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id="accounts.movement.detail.title" />
                    </div>
                </CustomProductHead>
                <MainContainer showLoader={fetchingState}>
                    <section className={`movement-details__receipt ${!isDesktop && "box box-primary flex-container"}`}>
                        <I18n id="accounts.movement.detail.voucher" />
                        <span
                            className={
                                !isDesktop && "movement-details__receipt-number"
                            }>{` Nº ${movement.receipt}`}</span>
                    </section>
                    <MovementDetailList movement={movement} {...props} />
                </MainContainer>{" "}
                {!isDesktop && (
                    <Options>
                        <AccountAction labelKey="global.download.pdf" />
                        <AccountAction labelKey="global.download.xls" />
                    </Options>
                )}
            </Fragment>
        )
    );
};

CustomMovementDetail.propTypes = customMovementDetailPropType;
CustomMovementDetail.defaultProps = defaultCustomMovementDetailPropType;

const mapStateToProps = (state) => ({
    account: accountsSelectors.getSelectedAccount(state),
    fetching: accountsSelectors.getFetching(state),
    movement: accountsSelectors.getSelectedMovement(state),
    voucher: accountsSelectors.getVoucher(state),
});

export default connect(mapStateToProps)(CustomMovementDetail);
